<template>
     <h5 v-if="percent >= 0">Meetings
        <ProgressBar :percent="percent" />
     </h5>
</template>
<script>
import ProgressBar from '@/components/ProgressBar';
export default {
    name: "ProgressBarMeetings",
    components: {
        ProgressBar,
    },
    computed: {
        percent() {
            return this.$store.state.meetings.loading;
        },
    }
}
</script>
<style>

</style>